<script setup>
const props = defineProps({
    data: Object
})
const placeholderText = props.data.searchPlaceholderText ? props.data.searchPlaceholderText : 'Find a location near...'
</script>


<template>
    <LocationSearchForm :placeholderText="placeholderText"/>
</template>